import React, { useEffect, useState } from "react";
import { getNews } from "../Service/Api"; 
import { Link } from 'react-router-dom';  

const News = () => { 
  const [circularData, setCircularData] = useState([]);   
  useEffect(() => {
    const fetchData = async () => {
      try {
        
        const cirData1 = await getNews();
         const cirData = cirData1.filter((item) =>  item.category === "News" || item.category ==="Both Sections" ); 
          cirData.sort((a,b) => new Date(b.fromDate) - new Date(a.fromDate)); 
        setCircularData(cirData || []);
      } catch (error) {
        console.error("Failed to fetch news:", error); 
        setCircularData([]);
      }
    };
    fetchData();
  }, []);

  const emptyArray = [
      {title:"Stay Tunned for More Updates" },
  ];
   
  return (
    <>
    <div className="newsbg">
    <div className='mainstitle'>  
        <h2> Circulars </h2> 
    <Link to="/News"><img src="https://webapi.entab.info/api/image/SJCSQP/public/Images/newsarrow.png" className="img-fluid"/></Link> 
    </div>
    <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
      <ul className="newsboxlist"> 
            {(circularData.length > 0 ? circularData : emptyArray).map((item, index) => (   
          <li key={index}>
          <div className="newsbox">
              <div className="newsdesc"> 
                <p> {item.title} </p>
              </div>  
                {item.attachments && item.attachments[0] && ( 
                    <Link to={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank"><i className="bi bi-paperclip"></i></Link> 
                )}
            </div>
           </li>
           ))
         }   
      </ul>
    </marquee>
  </div>
   
    </>
  );
};

export default News;
